'use client';

const benefits = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 28, height: 28 }}>
        <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.46 2.5 2.5 0 0 1-1.04-4.97A2.5 2.5 0 0 1 4 12a2.5 2.5 0 0 1 2-2.45V9.5A2.5 2.5 0 0 1 9.5 2Z"/>
        <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.46 2.5 2.5 0 0 0 1.04-4.97A2.5 2.5 0 0 0 20 12a2.5 2.5 0 0 0-2-2.45V9.5A2.5 2.5 0 0 0 14.5 2Z"/>
      </svg>
    ),
    title: 'Use Your Brain to Full Capacity',
    description: 'Unlock untapped cognitive potential with games that challenge every part of your brain.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 28, height: 28 }}>
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
      </svg>
    ),
    title: 'Sharper Focus Every Day',
    description: 'Train your attention span and reduce distractions with targeted focus exercises.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 28, height: 28 }}>
        <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
      </svg>
    ),
    title: 'Laser-Sharp Concentration',
    description: 'Build deep concentration skills that transfer to real-world tasks at work and home.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 28, height: 28 }}>
        <polyline points="9 11 12 14 22 4"/>
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
      </svg>
    ),
    title: 'Boost Calculation Skills',
    description: 'Speed math, pattern logic, and number games keep your analytical mind razor-sharp.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 28, height: 28 }}>
        <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
        <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
        <path d="M4 22h16"/>
        <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>
        <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>
        <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
      </svg>
    ),
    title: 'Impress With Your Abilities',
    description: 'Develop cognitive skills that let you think faster and impress in every conversation.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 28, height: 28 }}>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    title: 'Stay Sharp at Any Age',
    description: 'Consistent training helps maintain cognitive fitness from your 20s through your 80s.',
  },
];

const gameTypes = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 24, height: 24 }}>
        <rect x="2" y="2" width="8" height="8" rx="2"/><rect x="14" y="2" width="8" height="8" rx="2"/>
        <rect x="2" y="14" width="8" height="8" rx="2"/>
        <path d="M18 14v8M14 18h8"/>
      </svg>
    ),
    color: '#7C3AED', bg: '#F5F3FF', title: 'Logic Puzzles', description: 'Sharpen deductive reasoning and spatial awareness.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 24, height: 24 }}>
        <path d="M4 9h16M4 15h16M10 3 8 21M16 3l-2 18"/>
      </svg>
    ),
    color: '#2563EB', bg: '#EFF6FF', title: 'Speed Math', description: 'Train rapid calculation and numerical fluency.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 24, height: 24 }}>
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10"/>
        <path d="M12 6v6l4 2"/>
        <path d="M18 2l4 4-4 4"/>
        <path d="M22 2h-4v4"/>
      </svg>
    ),
    color: '#059669', bg: '#ECFDF5', title: 'Memory Games', description: 'Strengthen short and long-term memory recall.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 24, height: 24 }}>
        <circle cx="12" cy="12" r="10"/>
        <circle cx="12" cy="12" r="4"/>
        <line x1="12" y1="2" x2="12" y2="4"/>
        <line x1="12" y1="20" x2="12" y2="22"/>
        <line x1="2" y1="12" x2="4" y2="12"/>
        <line x1="20" y1="12" x2="22" y2="12"/>
      </svg>
    ),
    color: '#DC2626', bg: '#FEF2F2', title: 'Attention Training', description: 'Build sustained focus and filter out distractions.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 24, height: 24 }}>
        <path d="M4 7V4h16v3"/>
        <path d="M9 20h6"/>
        <path d="M12 4v16"/>
        <path d="M5 20h14"/>
      </svg>
    ),
    color: '#D97706', bg: '#FFFBEB', title: 'Word & Language', description: 'Expand vocabulary and verbal reasoning speed.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 24, height: 24 }}>
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
      </svg>
    ),
    color: '#0891B2', bg: '#ECFEFF', title: 'Reaction Speed', description: 'Develop lightning-fast cognitive reaction time.',
  },
];

export function BenefitsGrid() {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: 20,
    }}>
      {benefits.map((b) => (
        <div
          key={b.title}
          style={{
            background: 'white',
            borderRadius: 18,
            padding: '28px 24px',
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: '1px solid #F3F4F6',
            transition: 'transform 0.2s, box-shadow 0.2s',
            cursor: 'default',
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-4px)';
            (e.currentTarget as HTMLDivElement).style.boxShadow = '0 12px 32px rgba(37,99,235,0.12)';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLDivElement).style.transform = 'none';
            (e.currentTarget as HTMLDivElement).style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
          }}
        >
          <div style={{
            width: 56, height: 56, borderRadius: '50%',
            background: '#EFF6FF', margin: '0 auto 16px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#2563EB',
          }}>
            {b.icon}
          </div>
          <h3 style={{ fontSize: 15, fontWeight: 700, color: '#111827', marginBottom: 8 }}>{b.title}</h3>
          <p style={{ fontSize: 13, color: '#9CA3AF', lineHeight: 1.65 }}>{b.description}</p>
        </div>
      ))}
    </div>
  );
}

export function GameTypesGrid() {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
      gap: 16,
    }}>
      {gameTypes.map((g) => (
        <div
          key={g.title}
          style={{
            background: 'white',
            borderRadius: 16,
            padding: '24px 20px',
            border: '1px solid #F3F4F6',
            boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
            display: 'flex',
            alignItems: 'flex-start',
            gap: 14,
            transition: 'transform 0.2s',
            cursor: 'default',
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-3px)';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLDivElement).style.transform = 'none';
          }}
        >
          <div style={{
            width: 44, height: 44, borderRadius: 12,
            background: g.bg, flexShrink: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: g.color,
          }}>
            {g.icon}
          </div>
          <div>
            <h3 style={{ fontSize: 14, fontWeight: 700, color: '#111827', marginBottom: 4 }}>{g.title}</h3>
            <p style={{ fontSize: 13, color: '#9CA3AF', lineHeight: 1.55 }}>{g.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
